import { createSelector } from '@ngrx/store'
import { selectCreditState } from '../credit.selectors'

const selectGroupState = createSelector(selectCreditState, (state) => state.group)

export const selectGroupFilters = createSelector(selectGroupState, (state) => state.filters)

export const selectCurrentCreditGroup = createSelector(
  selectGroupState,
  (state) => state.currentCreditStructureGroupEntity,
)

export const selectCurrentCreditGroupMembers = createSelector(
  selectGroupState,
  (state) => state.currentCreditStructureGroupMemberEntities,
)

export const isGroupDirty = createSelector(selectGroupState, (state) => state.isDirty)

export const isGroupSaving = createSelector(selectGroupState, (state) => state.isSaving)
